var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g2, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoppyIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 325,
    viewBox: "0 0 480 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.344 112.985H116.784C115.406 112.985 114.29 114.101 114.29 115.479V189.455C114.29 190.833 115.406 191.949 116.784 191.949H158.344C159.721 191.949 160.837 190.833 160.837 189.455V115.479C160.837 114.101 159.721 112.985 158.344 112.985Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.916 124.206H118.446V126.115H155.916V124.206Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.606 124.206H118.446V126.115H125.606V124.206Z",
    fill: "#AB197B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.789 124.206H128.231V126.115H142.789V124.206Z",
    fill: "#A31979"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.916 124.206H145.415V126.115H155.916V124.206Z",
    fill: "#AB197B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.325 128.741H122.981V130.65H147.325V128.741Z",
    fill: "#F8F8F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 128.741H122.981V130.65H130.141V128.741Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.324 128.741H133.004V130.65H147.324V128.741Z",
    fill: "#AB197B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.325 132.798H122.981V134.707H147.325V132.798Z",
    fill: "#F8F8F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 132.798H122.981V134.707H130.141V132.798Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.324 132.798H133.004V134.707H147.324V132.798Z",
    fill: "#AB197B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 137.333H118.446V139.242H144.221V137.333Z",
    fill: "#F8F8F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.606 137.332H118.446V139.241H125.606V137.332Z",
    fill: "#AB197B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.529 137.333H128.515V139.242H155.529V137.333Z",
    fill: "#AB197B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.313 141.867H120.356V143.776H142.313V141.867Z",
    fill: "#F8F8F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.516 141.867H120.356V143.776H127.516V141.867Z",
    fill: "#A31979"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.313 141.867H130.141V143.776H142.313V141.867Z",
    fill: "#AB197B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.539 146.402H129.424V148.311H137.539V146.402Z",
    fill: "#F8F8F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M155.916 152.467H118.446V154.376H155.916V152.467Z",
    fill: "#F8F8F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.606 152.467H118.446V154.376H125.606V152.467Z",
    fill: "#AB197B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M142.789 152.467H128.231V154.376H142.789V152.467Z",
    fill: "#A31979"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M155.916 152.467H145.415V154.376H155.916V152.467Z",
    fill: "#AB197B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M147.325 157.002H122.981V158.911H147.325V157.002Z",
    fill: "#F8F8F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 157.002H122.981V158.911H130.141V157.002Z",
    fill: "#D9D9D9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.324 157.002H133.004V158.911H147.324V157.002Z",
    fill: "#AB197B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.325 161.059H122.981V162.968H147.325V161.059Z",
    fill: "#F8F8F8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 161.059H122.981V162.968H130.141V161.059Z",
    fill: "#D9D9D9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M147.324 161.059H133.004V162.968H147.324V161.059Z",
    fill: "#AB197B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 165.593H118.446V167.502H144.221V165.593Z",
    fill: "#F8F8F8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M125.606 165.594H118.446V167.503H125.606V165.594Z",
    fill: "#AB197B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M155.529 165.593H128.515V167.502H155.529V165.593Z",
    fill: "#AB197B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.313 170.128H120.356V172.037H142.313V170.128Z",
    fill: "#F8F8F8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.516 170.128H120.356V172.037H127.516V170.128Z",
    fill: "#A31979"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M142.313 170.128H130.141V172.037H142.313V170.128Z",
    fill: "#AB197B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M137.539 174.663H129.424V176.572H137.539V174.663Z",
    fill: "#F8F8F8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M119.349 118.947C119.848 118.947 120.252 118.543 120.252 118.044C120.252 117.545 119.848 117.141 119.349 117.141C118.85 117.141 118.446 117.545 118.446 118.044C118.446 118.543 118.85 118.947 119.349 118.947Z",
    fill: "#A31979"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.986 118.947C122.485 118.947 122.889 118.543 122.889 118.044C122.889 117.545 122.485 117.141 121.986 117.141C121.487 117.141 121.083 117.545 121.083 118.044C121.083 118.543 121.487 118.947 121.986 118.947Z",
    fill: "#AB197B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.623 118.947C125.122 118.947 125.526 118.543 125.526 118.044C125.526 117.545 125.122 117.141 124.623 117.141C124.124 117.141 123.72 117.545 123.72 118.044C123.72 118.543 124.124 118.947 124.623 118.947Z",
    fill: "#AB197B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M270.556 112.985H167.903C166.525 112.985 165.409 114.101 165.409 115.479V189.455C165.409 190.833 166.525 191.949 167.903 191.949H270.556C271.934 191.949 273.05 190.833 273.05 189.455V115.479C273.05 114.101 271.934 112.985 270.556 112.985Z",
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 112,
    width: 109,
    height: 80
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M165.409 117.972C165.409 115.621 165.409 114.446 166.139 113.716C166.87 112.985 168.045 112.985 170.396 112.985H268.062C270.413 112.985 271.589 112.985 272.319 113.716C273.049 114.446 273.049 115.621 273.049 117.972V186.962C273.049 189.313 273.049 190.489 272.319 191.219C271.589 191.949 270.413 191.949 268.062 191.949H170.396C168.045 191.949 166.87 191.949 166.139 191.219C165.409 190.489 165.409 189.313 165.409 186.962V117.972Z",
    fill: "#D55151"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.869 123.375H170.396V125.284H264.869V123.375Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.556 123.375H170.396V125.284H177.556V123.375Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.607 123.375H180.049V125.284H194.607V123.375Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.659 123.375H197.101V125.284H211.659V123.375Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.711 123.375H214.153V125.284H228.711V123.375Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.869 123.375H231.205V125.284H264.869V123.375Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.142 127.91H176.794V129.819H211.142V127.91Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.954 127.909H176.794V129.818H183.954V127.909Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.398 127.909H186.863V129.818H238.398V127.909Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.467 127.909H241.307V129.818H248.467V127.909Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.142 131.967H176.794V133.876H211.142V131.967Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.954 131.967H176.794V133.876H183.954V131.967Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.398 131.967H186.863V133.876H238.398V131.967Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.467 131.967H241.307V133.876H248.467V131.967Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.585 136.674H170.396V138.336H222.585V136.674Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.555 136.674H170.395V138.583H177.555V136.674Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.401 136.674H180.465V138.583H205.401V136.674Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.375 136.674H208.31V138.752H215.375V136.674Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.349 136.674H218.284V138.752H225.349V136.674Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.323 136.674H228.258V138.752H235.323V136.674Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.298 136.674H238.233V138.752H245.298V136.674Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 141.036H173.09V142.945H204.07V141.036Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.25 141.036H173.09V142.945H180.25V141.036Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.488 141.036H182.875V142.945H236.488V141.036Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.869 149.974H170.396V151.883H264.869V149.974Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.556 149.974H170.396V151.883H177.556V149.974Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.607 149.974H180.049V151.883H194.607V149.974Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.659 149.974H197.101V151.883H211.659V149.974Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.711 149.974H214.153V151.883H228.711V149.974Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.869 149.974H231.205V151.883H264.869V149.974Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.142 154.508H176.794V156.417H211.142V154.508Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.954 154.508H176.794V156.417H183.954V154.508Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.398 154.508H186.863V156.417H238.398V154.508Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.467 154.508H241.307V156.417H248.467V154.508Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.142 158.565H176.794V160.474H211.142V158.565Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.954 158.565H176.794V160.474H183.954V158.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.398 158.565H186.863V160.474H238.398V158.565Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.467 158.565H241.307V160.474H248.467V158.565Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.585 163.273H170.396V164.935H222.585V163.273Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.555 163.273H170.395V165.182H177.555V163.273Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.401 163.273H180.465V165.182H205.401V163.273Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.375 163.273H208.31V165.351H215.375V163.273Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.349 163.273H218.284V165.351H225.349V163.273Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.323 163.273H228.258V165.351H235.323V163.273Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.298 163.273H238.233V165.351H245.298V163.273Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 167.635H173.09V169.544H204.07V167.635Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.25 167.635H173.09V169.544H180.25V167.635Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.488 167.635H182.875V169.544H236.488V167.635Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.883 118.947C171.382 118.947 171.786 118.543 171.786 118.044C171.786 117.545 171.382 117.141 170.883 117.141C170.384 117.141 169.98 117.545 169.98 118.044C169.98 118.543 170.384 118.947 170.883 118.947Z",
    fill: "#A31979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.52 118.947C174.019 118.947 174.423 118.543 174.423 118.044C174.423 117.545 174.019 117.141 173.52 117.141C173.021 117.141 172.617 117.545 172.617 118.044C172.617 118.543 173.021 118.947 173.52 118.947Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.157 118.947C176.656 118.947 177.06 118.543 177.06 118.044C177.06 117.545 176.656 117.141 176.157 117.141C175.658 117.141 175.254 117.545 175.254 118.044C175.254 118.543 175.658 118.947 176.157 118.947Z",
    fill: "#AB197B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.05 178.65H165.409V191.949H273.05V178.65Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.853 188.624C221.919 188.624 223.593 186.95 223.593 184.884C223.593 182.818 221.919 181.144 219.853 181.144C217.787 181.144 216.113 182.818 216.113 184.884C216.113 186.95 217.787 188.624 219.853 188.624Z",
    fill: "#D9D9D9"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M321.675 112.985H280.115C278.737 112.985 277.621 114.101 277.621 115.479V189.455C277.621 190.833 278.737 191.949 280.115 191.949H321.675C323.052 191.949 324.168 190.833 324.168 189.455V115.479C324.168 114.101 323.052 112.985 321.675 112.985Z",
    fill: "#F8F8F8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M319.247 124.206H281.777V126.115H319.247V124.206Z",
    fill: "#F8F8F8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M288.937 124.206H281.777V126.115H288.937V124.206Z",
    fill: "#AB197B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M306.12 124.206H291.562V126.115H306.12V124.206Z",
    fill: "#A31979"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M319.247 124.206H308.746V126.115H319.247V124.206Z",
    fill: "#AB197B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M310.656 128.741H286.312V130.65H310.656V128.741Z",
    fill: "#F8F8F8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M293.472 128.741H286.312V130.65H293.472V128.741Z",
    fill: "#D9D9D9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M310.656 128.741H296.336V130.65H310.656V128.741Z",
    fill: "#AB197B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M310.656 132.798H286.312V134.707H310.656V132.798Z",
    fill: "#F8F8F8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M293.472 132.798H286.312V134.707H293.472V132.798Z",
    fill: "#D9D9D9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M310.656 132.798H296.336V134.707H310.656V132.798Z",
    fill: "#AB197B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M307.553 137.333H281.777V139.242H307.553V137.333Z",
    fill: "#F8F8F8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M288.938 137.333H281.778V139.242H288.938V137.333Z",
    fill: "#AB197B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M318.86 137.333H291.846V139.242H318.86V137.333Z",
    fill: "#AB197B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M305.644 141.867H283.687V143.776H305.644V141.867Z",
    fill: "#F8F8F8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M290.847 141.867H283.687V143.776H290.847V141.867Z",
    fill: "#A31979"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M305.644 141.867H293.472V143.776H305.644V141.867Z",
    fill: "#AB197B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M300.871 146.402H292.756V148.311H300.871V146.402Z",
    fill: "#F8F8F8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M319.247 152.467H281.777V154.376H319.247V152.467Z",
    fill: "#F8F8F8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M288.937 152.467H281.777V154.376H288.937V152.467Z",
    fill: "#AB197B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M306.12 152.467H291.562V154.376H306.12V152.467Z",
    fill: "#A31979"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M319.247 152.467H308.746V154.376H319.247V152.467Z",
    fill: "#AB197B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M310.656 157.002H286.312V158.911H310.656V157.002Z",
    fill: "#F8F8F8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M293.472 157.002H286.312V158.911H293.472V157.002Z",
    fill: "#D9D9D9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M310.656 157.002H296.336V158.911H310.656V157.002Z",
    fill: "#AB197B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M310.656 161.059H286.312V162.968H310.656V161.059Z",
    fill: "#F8F8F8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M293.472 161.059H286.312V162.968H293.472V161.059Z",
    fill: "#D9D9D9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M310.656 161.059H296.336V162.968H310.656V161.059Z",
    fill: "#AB197B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M307.553 165.593H281.777V167.502H307.553V165.593Z",
    fill: "#F8F8F8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M288.938 165.594H281.778V167.503H288.938V165.594Z",
    fill: "#AB197B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M318.86 165.594H291.846V167.503H318.86V165.594Z",
    fill: "#AB197B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M305.644 170.128H283.687V172.037H305.644V170.128Z",
    fill: "#F8F8F8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M290.847 170.128H283.687V172.037H290.847V170.128Z",
    fill: "#A31979"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M305.644 170.128H293.472V172.037H305.644V170.128Z",
    fill: "#AB197B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M300.871 174.663H292.756V176.572H300.871V174.663Z",
    fill: "#F8F8F8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M282.68 118.947C283.179 118.947 283.583 118.543 283.583 118.044C283.583 117.545 283.179 117.141 282.68 117.141C282.181 117.141 281.777 117.545 281.777 118.044C281.777 118.543 282.181 118.947 282.68 118.947Z",
    fill: "#A31979"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M285.317 118.947C285.816 118.947 286.22 118.543 286.22 118.044C286.22 117.545 285.816 117.141 285.317 117.141C284.818 117.141 284.414 117.545 284.414 118.044C284.414 118.543 284.818 118.947 285.317 118.947Z",
    fill: "#AB197B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M287.954 118.947C288.453 118.947 288.857 118.543 288.857 118.044C288.857 117.545 288.453 117.141 287.954 117.141C287.455 117.141 287.051 117.545 287.051 118.044C287.051 118.543 287.455 118.947 287.954 118.947Z",
    fill: "#AB197B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M210.294 191.949H228.58L233.567 212.314H205.514L210.294 191.949Z",
    fill: "#D9D9D9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M219.229 324.111C98.1522 324.111 0 310.993 0 294.811C0 278.629 98.1522 265.511 219.229 265.511C340.306 265.511 438.458 278.629 438.458 294.811C438.458 310.993 340.306 324.111 219.229 324.111Z",
    fill: "#F0F0F0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M410.897 287.264C398.016 274.571 417.728 241.465 417.728 241.465",
    stroke: "#D1D5DA",
    strokeWidth: 0.794031,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M417.626 234.825C418.874 231.567 423.624 228.206 423.624 228.206C423.624 228.206 424.711 234.276 422.916 237.397C421.461 239.929 417.161 242.172 417.161 242.172C417.161 242.172 416.597 237.509 417.626 234.825Z",
    fill: "#959DA5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M408.21 243.931C406.608 240.832 407.256 235.049 407.256 235.049C407.256 235.049 412.513 238.275 413.65 241.691C414.573 244.461 413.388 249.164 413.388 249.164C413.388 249.164 409.531 246.485 408.21 243.931Z",
    fill: "#EDF0F2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M403.015 257.168C401.413 254.07 402.061 248.287 402.061 248.287C402.061 248.287 407.317 251.513 408.455 254.928C409.378 257.699 408.193 262.402 408.193 262.402C408.193 262.402 404.336 259.722 403.015 257.168Z",
    fill: "#EDF0F2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M400.284 269.857C398.286 266.997 398.164 261.18 398.164 261.18C398.164 261.18 403.801 263.682 405.38 266.917C406.662 269.541 406.109 274.359 406.109 274.359C406.109 274.359 401.931 272.214 400.284 269.857Z",
    fill: "#EDF0F2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M420.381 253.135C417.355 254.871 411.549 254.475 411.549 254.475C411.549 254.475 414.543 249.083 417.906 247.798C420.634 246.755 425.384 247.734 425.384 247.734C425.384 247.734 422.875 251.705 420.381 253.135Z",
    fill: "#D1D5DA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M416.248 265.915C413.222 267.65 407.416 267.254 407.416 267.254C407.416 267.254 410.41 261.863 413.773 260.577C416.501 259.535 421.251 260.514 421.251 260.514C421.251 260.514 418.742 264.484 416.248 265.915Z",
    fill: "#D1D5DA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M415.76 278.383C412.734 280.118 406.929 279.722 406.929 279.722C406.929 279.722 409.923 274.331 413.285 273.045C416.013 272.003 420.763 272.982 420.763 272.982C420.763 272.982 418.254 276.952 415.76 278.383Z",
    fill: "#D1D5DA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M402.323 284.242C412.635 269.386 387.142 240.495 387.142 240.495",
    stroke: "#D1D5DA",
    strokeWidth: 0.794031,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M386.016 233.95C384.187 230.98 378.897 228.554 378.897 228.554C378.897 228.554 378.952 234.721 381.292 237.457C383.19 239.676 387.831 241.084 387.831 241.084C387.831 241.084 387.523 236.398 386.016 233.95Z",
    fill: "#959DA5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M396.953 241.159C397.954 237.817 396.248 232.254 396.248 232.254C396.248 232.254 391.679 236.396 391.192 239.963C390.798 242.856 392.832 247.259 392.832 247.259C392.832 247.259 396.127 243.913 396.953 241.159Z",
    fill: "#EDF0F2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M404.505 253.208C405.507 249.866 403.8 244.303 403.8 244.303C403.8 244.303 399.231 248.445 398.745 252.012C398.35 254.906 400.384 259.308 400.384 259.308C400.384 259.308 403.679 255.962 404.505 253.208Z",
    fill: "#EDF0F2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M386.694 252.454C389.988 253.601 395.621 252.138 395.621 252.138C395.621 252.138 391.682 247.393 388.139 246.751C385.266 246.231 380.779 248.072 380.779 248.072C380.779 248.072 383.978 251.509 386.694 252.454Z",
    fill: "#D1D5DA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M393.117 264.25C396.412 265.396 402.044 263.933 402.044 263.933C402.044 263.933 398.105 259.188 394.563 258.547C391.689 258.026 387.202 259.867 387.202 259.867C387.202 259.867 390.402 263.305 393.117 264.25Z",
    fill: "#D1D5DA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M395.901 276.413C399.196 277.559 404.828 276.096 404.828 276.096C404.828 276.096 400.89 271.351 397.347 270.71C394.473 270.189 389.986 272.03 389.986 272.03C389.986 272.03 393.186 275.468 395.901 276.413Z",
    fill: "#D1D5DA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M397.737 260.822C397.737 260.822 398.647 243.85 395.243 233.824C392.959 227.097 386.773 217.724 386.773 217.724",
    stroke: "#D1D5DA",
    strokeWidth: 0.226866
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M405.552 289.616C397.933 289.616 395.797 281.448 395.797 281.448H415.308C415.308 281.448 413.172 289.616 405.552 289.616Z",
    fill: "#D9D9D9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M354.923 207.327H83.9514V292.941H354.923V207.327Z",
    fill: "#D1D5DA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M376.949 197.768H61.9245V207.327H376.949V197.768Z",
    fill: "#F8F8F8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2366 197.767V292.94H83.9514V197.767H70.2366Z",
    fill: "#F8F8F8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M354.923 197.767V292.94H368.638V197.767H354.923Z",
    fill: "#F8F8F8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M296.739 197.767V292.94H304.635V197.767H296.739Z",
    fill: "#F8F8F8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 279.225H296.739V292.94H368.638V279.225Z",
    fill: "#F8F8F8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M144.744 168.979C139.418 159.717 158.058 136.933 163.606 133.418C169.154 129.903 168.266 131.764 168.266 131.764L163.606 187.793C159.538 185.381 150.07 178.242 144.744 168.979Z",
    fill: "#6B137A"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M256.633 136.051C248.124 127.905 216.528 125.245 216.528 125.245C218.398 146.302 218.768 173.335 240.425 190.287C259.24 205.014 278.66 198.46 296.531 197.56V191.742C296.531 191.742 273.868 192.437 262.244 180.52C249.053 166.998 270.279 149.114 256.633 136.051Z",
    fill: "#6B137A"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M221.553 219.593C221.553 219.593 273.08 150.426 242.956 132.732C229.961 125.099 219.321 125.077 203.992 125.044H203.682C188.186 125.011 178.165 124.851 164.823 132.732C135.211 150.226 179.369 219.593 179.369 219.593H221.553Z",
    fill: "#AB197B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M210.229 126.265L209.961 114.705C209.961 114.705 207.528 114.017 206.106 113.27C203.792 112.055 201.056 108.892 201.056 108.892L199.139 126.512L210.229 126.265Z",
    fill: "#FFDAB8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M203.604 113.887C202.073 112.3 201.056 108.892 201.056 108.892L210.062 114.795L209.983 115.954L209.903 117.113C209.903 117.113 205.523 115.876 203.604 113.887Z",
    fill: "#EDC199"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M206.699 115.27C214.902 116.972 223.584 108.562 226.09 96.4853C228.596 84.4086 223.978 73.2384 215.775 71.5362C207.572 69.8339 198.89 78.2441 196.384 90.3209C193.878 102.398 198.496 113.568 206.699 115.27Z",
    fill: "#FFDAB8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M197.587 103.78C218.91 104.406 207.562 91.1575 214.322 91.1575C217.032 91.1575 217.367 97.3917 217.367 97.3917L222.731 89.4177L228.58 88.2571C228.58 88.2571 227.952 75.0791 224.424 72.672C219.704 69.4518 213.514 69.0804 208.216 71.2175C191.799 73.7112 194.293 87.8414 194.293 87.8414C194.293 87.8414 192.631 103.634 197.587 103.78Z",
    fill: "#07122A"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M177.877 223.535L179.332 219.379H221.931C221.931 219.379 240.747 231.042 242.503 243.484C245.228 262.787 206.346 288.576 206.346 288.576V282.966C206.346 282.966 220.737 263.988 218.606 250.757C217.342 242.91 205.723 237.458 205.723 237.458C205.723 237.458 189.129 235.391 183.903 245.354C177.212 258.114 198.657 280.888 198.657 280.888V285.252C198.657 285.252 162.618 266.77 163.331 249.302C163.803 237.756 177.877 223.535 177.877 223.535Z",
    fill: "#07122A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M228.788 235.172H176.007C170.613 235.172 166.24 239.545 166.24 244.939C166.24 250.333 170.613 254.705 176.007 254.705H228.788C234.182 254.705 238.554 250.333 238.554 244.939C238.554 239.545 234.182 235.172 228.788 235.172Z",
    fill: "#AB197B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 235,
    width: 73,
    height: 20
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M228.788 235.172H176.007C170.613 235.172 166.24 239.545 166.24 244.939C166.24 250.333 170.613 254.705 176.007 254.705H228.788C234.182 254.705 238.554 250.333 238.554 244.939C238.554 239.545 234.182 235.172 228.788 235.172Z",
    fill: "#FFD200"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.697 235.172H173.097C169.31 235.172 166.24 238.242 166.24 242.029C166.24 245.817 169.31 248.887 173.097 248.887H231.697C235.484 248.887 238.554 245.817 238.554 242.029C238.554 238.242 235.484 235.172 231.697 235.172Z",
    fill: "#FF3BC3"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M206.553 254.705H198.657V307.486H206.553V254.705Z",
    fill: "#6A737D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M231.49 305.824H173.721V310.396H231.49V305.824Z",
    fill: "#6A737D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M173.721 305.824V315.383H176.63V305.824H173.721Z",
    fill: "#6A737D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M201.151 305.824V315.383H204.06V305.824H201.151Z",
    fill: "#6A737D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M228.58 305.824V315.383H231.489V305.824H228.58Z",
    fill: "#6A737D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M305.466 197.56L296.531 192.573V197.56H305.466Z",
    fill: "#FFDAB8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M333.113 39.8707C341.637 39.8707 348.547 32.9607 348.547 24.4369C348.547 15.913 341.637 9.00305 333.113 9.00305C324.589 9.00305 317.679 15.913 317.679 24.4369C317.679 32.9607 324.589 39.8707 333.113 39.8707Z",
    stroke: "#AB197B",
    strokeWidth: 2.5723
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M69.881 93.0316C75.09 93.0316 79.3128 88.8089 79.3128 83.5999C79.3128 78.3908 75.09 74.1681 69.881 74.1681C64.672 74.1681 60.4492 78.3908 60.4492 83.5999C60.4492 88.8089 64.672 93.0316 69.881 93.0316Z",
    stroke: "#AB197B",
    strokeWidth: 2.5723
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0122 193.351C39.0903 193.351 41.5855 190.856 41.5855 187.778C41.5855 184.7 39.0903 182.205 36.0122 182.205C32.9341 182.205 30.4389 184.7 30.4389 187.778C30.4389 190.856 32.9341 193.351 36.0122 193.351Z",
    stroke: "#AB197B",
    strokeWidth: 2.5723
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M103.321 186.92C105.452 186.92 107.179 185.193 107.179 183.062C107.179 180.931 105.452 179.203 103.321 179.203C101.19 179.203 99.4625 180.931 99.4625 183.062C99.4625 185.193 101.19 186.92 103.321 186.92Z",
    stroke: "#AB197B",
    strokeWidth: 1.71487
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M197.773 9.14785L192.075 4.31014C190.451 2.93093 188.016 3.12974 186.637 4.75418L181.799 10.4521C180.42 12.0765 180.619 14.5115 182.243 15.8907L187.941 20.7284C189.565 22.1076 192 21.9088 193.38 20.2843L198.217 14.5864C199.596 12.962 199.398 10.5271 197.773 9.14785Z",
    stroke: "#E6E9ED",
    strokeWidth: 2.5723
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M456.511 215.302L468.844 206.989L469.876 221.826L456.511 215.302Z",
    stroke: "#AB197B",
    strokeWidth: 2.5723
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoppyIllustration);
export default __webpack_public_path__ + "static/media/poppy-illustration.6d09b7223a76d55ef10760169b774b10.svg";
export { ForwardRef as ReactComponent };